import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  ModalOverlay,
  ModalContent,
} from "@chakra-ui/react";

export default function ModalEnterpriseError({ open, onClose }) {
  return (
    <Modal isOpen={open} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Uh-oh! You&apos;re signed in to a college admit account.</ModalHeader>

        <ModalBody>
          Please create a new account as a school or counsellor to purchase something.
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
